"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Filter = _interopRequireDefault(require("../Filter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SpecializedSupportFilter = function SpecializedSupportFilter(props) {
  var accessibility = props.accessibility,
    label = props.label,
    languages = props.languages,
    onFiltersChange = props.onFiltersChange,
    populations = props.populations;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-filter-section ui-specialized-support-section"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "ui-filter-section__label"
  }, label), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
    filterKey: "catersTo",
    name: "Populations Specialized in Serving",
    onFiltersChange: onFiltersChange,
    options: populations,
    pluralName: "Populations Specialized in Serving"
  }), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
    filterKey: "accessibility",
    name: "Accessibility",
    onFiltersChange: onFiltersChange,
    options: accessibility,
    pluralName: "Accessibility"
  }), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
    filterKey: "languages",
    name: "Language",
    onFiltersChange: onFiltersChange,
    options: languages
  }));
};
SpecializedSupportFilter.propTypes = {
  /** array of accessibility options */
  accessibility: _propTypes["default"].array.isRequired,
  /** label of the filter group */
  label: _propTypes["default"].string.isRequired,
  /** array of languages options */
  languages: _propTypes["default"].array.isRequired,
  /**
   * @param {array} activeFilters array of selected filters
   * @param {string} key filterKey
   * @public
  */
  onFiltersChange: _propTypes["default"].func.isRequired,
  /** array of populations options */
  populations: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = SpecializedSupportFilter;